import { CellClassParams } from 'ag-grid/dist/lib/entities/colDef';
import { Component, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { GridOptions, GridReadyEvent, RowDoubleClickedEvent, CellClickedEvent } from 'ag-grid';
import { ComplaintsService } from '../../services/complaints.service';
import { IComplaintHistory } from '../../core/interfaces/complaint-history.interface';
import { Subscription } from 'rxjs/Subscription';
import { EventEmitter } from '@angular/common/src/facade/async';
import { SweetAlertHelper } from '../../core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-grid-complaints-responses',
  templateUrl: './grid-complaints-responses.component.html',
  styleUrls: ['./grid-complaints-responses.component.scss']
})

export class GridComplaintsResponsesComponent implements OnInit, OnChanges, OnDestroy {
  subscriptions: Subscription[] = [];
  @Output() emitGridData = new EventEmitter<IComplaintHistory>();
  @Input() noteId: number;
  @Input() rowData: IComplaintHistory[];
  @Input() isReservation = false;
  gridComplaintResponses: GridOptions;
  gridData: IComplaintHistory[] = [];

  constructor(private complaintService: ComplaintsService, private sweetAlertHelper: SweetAlertHelper) {
    this.createGrid();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['noteId'] && this.noteId && this.isReservation) {
      this.getHistorySearchByNote(this.noteId);
    }

    if (changes['rowData'] && this.rowData.length) {
      this.gridData = this.rowData;
    } else {
      this.gridData = [];
    }
  }

  ngOnInit() {

  }

  getFileAttachment(params: CellClickedEvent): void {
    if (params && params.data.hasattachment) {
      const { complainthistoryid } = params.data;
      this.subscriptions.push(
        this.complaintService.getFileAttachment(complainthistoryid).subscribe((res) => {
          if (res) {
            window.open(res, '_blank');
          }
        }, error => this.sweetAlertHelper.captureException(error))
      );
    }
  }

  createGrid() {
    this.gridComplaintResponses = <GridOptions> {
      enableSorting: true,
      enableColResize: true,
      rowSelection: 'single',
      enableFilter: true,
      columnDefs: [
        {
          headerName: 'Response',
          field: 'description',
          width: 250,
          autoHeight:true,
          cellStyle: {
            'whiteSpace': 'normal'
          }
        },
        {headerName: 'Date', field: 'date', width: 80},
        {headerName: 'Review Status', field: 'complaintreviewstatus', width: 100},
        {headerName: 'User', field: 'user', width: 80},
        {headerName: 'Complaint Status', field: 'complaintstatus', width: 80},
        {
          headerName: 'File',
          field: 'hasattachment',
          width: 70,
          cellStyle: { 'text-align': 'center' },
          onCellClicked: (params) =>  this.getFileAttachment(params),
          cellRenderer: (params: CellClassParams) => {
            if (params && params.data.hasattachment) {
              return '<i class="fa fa-file-text"></i>';
            }
          }
        },
      ],
      onGridReady: (event: GridReadyEvent) => {
        if (event) {
          this.gridComplaintResponses.api.sizeColumnsToFit();
        }
      },
      onRowDoubleClicked: (event: RowDoubleClickedEvent) => {
        if (event) {
          this.emitGridData.emit(event.data);
        }
      }
    };
  }

  getHistorySearchByNote(noteId) {
    this.subscriptions.push(
      this.complaintService.getHistorySearchByNote(noteId).subscribe(resp => {
        if (resp && resp.length) {
          this.gridData = resp;
        }
      }, error => {
        this.sweetAlertHelper.captureException(error.message).then();
      }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/grid-complaints-responses/grid-complaints-responses.component.ts